import { showApiError, showSuccess } from "@/lib/toast";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { updateHospitalMenuCategoryItem } from "@/sideEffects/api";
import { HospitalityMenuCategory, HospitalityMenuCategoryItem } from "@/lib/types";
import { FormSchemaType, HospitalityMenuCategoryItemMetaForm } from "../form/HospitalityMenuCategoryItemMetaForm";

interface Props {
  category: HospitalityMenuCategory;
  categoryItem: HospitalityMenuCategoryItem;
}

export const UpdateHospitalityMenuCategoryItemMetaForm: React.FC<Props> = ({ category, categoryItem }) => {
  const { t } = useTranslation();

  const updateHospitalMenuCategoryItemMutation = useMutation({
    mutationFn: (values: FormSchemaType) =>
      updateHospitalMenuCategoryItem({
        id: categoryItem.id,
        name: values.name ?? "",
        description: values.description ?? "",
        price: values.price ?? "",
        hospitalityMenuId: category.hMenu_Id,
        hospitalityMenuCategoryId: categoryItem.hMenuCategory_Id,
      }),
    onSuccess: () => {
      showSuccess(t("common.updatedSuccess"));
    },
    onError: showApiError,
  });

  return (
    <HospitalityMenuCategoryItemMetaForm
      buttonText={t("common.update")}
      onSubmit={(values) => updateHospitalMenuCategoryItemMutation.mutate(values)}
      isLoading={updateHospitalMenuCategoryItemMutation.isPending}
      defaultValues={{
        name: categoryItem.name ?? "",
        description: categoryItem.description ?? "",
        price: categoryItem.price ? String(categoryItem.price) : "",
      }}
    />
  );
};
